<template>
  <div class="flex items-center justify-center w-full h-full p-4 text-lg">
    <div class="pulsedot"></div>
  </div>
</template>
